import React from "react";
import { Link } from "react-router-dom";

const TeamArea = () => {
  return (
    <section className="team-area pt-130 pb-130">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="team-img-wrap">
              <img
                alt="Pricing Area"
                src="/img/my-img/pricing.webp"
                className="img-shape"
                style={{width: "20rem"}}
              />
              <img
                alt="Pricing Area"
                src="/img/pricingimg/pricing_1-01.webp"
                className="img-one"
              />
              <img
                alt="Pricing Area"
                src="/img/pricingimg/pricing_2-01.webp"
                className="img-two"
              />
              <img
                alt="Pricing Area"
                src="/img/pricingimg/pricing_3-01.webp"
                className="img-three"
              />
              <img
                alt="Pricing Area"
                src="/img/pricingimg/pricing_4-01.webp"
                className="img-four"
              />
              <img
                alt="Pricing Area"
                src="/img/pricingimg/pricing_5-01.webp"
                className="img-five"
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="team-content">
              <div className="section-title mb-25">
                <h3 className="sub-title">
                  Innovatix Design Agency Australia{" "}
                </h3>
                <h2 className="title">You Pay Less, We Add More</h2>
              </div>
              <p>
                With our reasonable and affordable graphic design services,
                leave your financial worries and focus on scaling your business
                to heights that are every business owner's dream.
              </p>
              <Link to="/pricing" className="btn">
                Get Pricing <span></span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="team-shape-wrap">
        <img
          alt="Pricing Area1"
          src="/img/images/team_shape01.webp"
          className="ribbonRotate"
        />
        <img
          alt="Pricing Area2"
          src="/img/images/team_shape02.webp"
          className="float-bob-x"
        />
      </div>
    </section>
  );
};

export default TeamArea;
